// extracted by mini-css-extract-plugin
export default {"button":"button_button__+bWd9","exit":"button_exit__PbYG6","submit":"button_submit__r77oE"};